import { cn } from '../../lib/utils';
import './ui.css';

export function Checkbox({ className, id, label, ...props }) {
  return (
    <label className="ui-checkbox-wrap" htmlFor={id}>
      <input id={id} type="checkbox" className={cn('ui-checkbox', className)} {...props} />
      {label ? <span>{label}</span> : null}
    </label>
  );
}
